import { useEffect } from 'react';
import NewRelic from 'new-relic-agent-react';
import { renderToString } from 'react-dom/server';

export const useNewRelic = () => {
    useEffect(() => {
        const loadScript = () => {
            const { REACT_APP_NEW_RELIC_APP_ID: applicationID, REACT_APP_NEW_RELIC_LICENCE_KEY: licenseKey } = process.env;
            const newRelicEnabled = process.env.REACT_APP_NEW_RELIC_ENABLED === 'true';

            if (!newRelicEnabled) {
                return;
            }

            // const newRelic = <NewRelic licenseKey="NRJS-1d06db54ffa6430628b" applicationID="1386058657"/>;
            const newRelic = <NewRelic licenseKey={licenseKey} applicationID={applicationID} />;
            const componentHtml = renderToString(newRelic);
            const scriptContentRegex = /<script[^>]*>([\s\S]*?)<\/script>/i;
            const javascriptCode = scriptContentRegex.exec(componentHtml);
            const pureJavascriptCode = javascriptCode && javascriptCode[1] ? javascriptCode[1].trim() : '';
            const script = document.createElement('script');
            script.textContent = pureJavascriptCode;
            const head = document.getElementsByTagName('head')[0];
            head.appendChild(script);
        };

        loadScript();
    }, []);
};
